import Button from '@app-studio-web/ui/components/Button'
import Layout from '@app-studio-web/ui/components/Layout'
import { useTranslation } from 'react-i18next'
import { Form, useSubmit } from 'react-router-dom'

export default function FeedbackOverwhelmPage() {
  const { t } = useTranslation()
  const submit = useSubmit()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    submit(event.currentTarget)
  }

  return (
    <Layout>
      <div className="fixed inset-0 -z-10 bg-gradient-to-b from-[#FFFFFF] to-[#EFFBFF]" />
      <div className="flex h-full flex-col text-center">
        <div className="flex grow flex-col items-center justify-center px-4">
          <div className="mb-6 text-6xl">🧠</div>

          <h1 className="custom-heading mb-4 text-2xl leading-tight">
            {t('pages.onboarding.feedbackOverwhelm.title')}
          </h1>

          <p className="mb-6 max-w-sm leading-relaxed text-gray-600">
            {t('pages.onboarding.feedbackOverwhelm.description')}
          </p>

          <div className="flex w-full max-w-sm flex-col gap-3">
            <div className="flex items-center gap-3 rounded-xl bg-white p-4 shadow-sm">
              <span className="text-2xl">✓</span>
              <p className="text-left text-sm text-gray-700">
                {t('pages.onboarding.feedbackOverwhelm.point1')}
              </p>
            </div>
            <div className="flex items-center gap-3 rounded-xl bg-white p-4 shadow-sm">
              <span className="text-2xl">✓</span>
              <p className="text-left text-sm text-gray-700">
                {t('pages.onboarding.feedbackOverwhelm.point2')}
              </p>
            </div>
            <div className="flex items-center gap-3 rounded-xl bg-white p-4 shadow-sm">
              <span className="text-2xl">✓</span>
              <p className="text-left text-sm text-gray-700">
                {t('pages.onboarding.feedbackOverwhelm.point3')}
              </p>
            </div>
          </div>
        </div>

        <Form className="shrink-0" method="post" onSubmit={handleSubmit}>
          <Button
            title={t('shared.continue')}
            type="submit"
            dataTestId="button-continue"
          />
        </Form>
      </div>
    </Layout>
  )
}
